<template>
  <FormSelect
      :name="name"
      :value="value"
      :items="items"
      :errors="errors"
      :disabled="disabled"
      :placeholder="placeholder"
      :filterable="filterable"
      :required="required"
      :hide-label="hideLabel"
      @change="onChange">
    <slot>{{ name }}</slot>
  </FormSelect>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import FormSelect from './FormSelect';

export default {
  name: 'SaxxSelect',
  components: {
    FormSelect,
  },
  props: {
    form: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String
    },
    items: {
      required: true,
      type: Array
    },
    filterable: {
      required: false,
      type: Boolean,
      default: true,
    },
    placeholder: {
      required: false,
      type: String,
      default: ''
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    hideLabel: {
      required: false,
      type: Boolean,
      default: false
    },
    change: {
      required: false,
      type: Function
    }
  },
  computed: {
    ...mapGetters('forms', [
      'getField',
      'getErrors',
      'getFieldIsDisabled',
    ]),
    value() {
      return this.getField({
        form: this.form,
        field: this.name,
      });
    },
    errors() {
      return this.getErrors({
        form: this.form,
        field: this.name,
      });
    },
    hasErrors() {
      return this.errors.length > 0;
    },
    isNotEmpty() {
      return (
          String(this.value).length > 0
      );
    },
    disabled() {
      return this.getFieldIsDisabled({form: this.form, field: this.name});
    },
  },
  methods: {
    ...mapActions('forms', [
      'setField',
    ]),
    onChange(value) {
      this.setField({
        form: this.form,
        field: this.name,
        value,
      });
      if(typeof this.change != 'undefined') this.change(value)
    },
  },
}
</script>
